// extracted by mini-css-extract-plugin
export default {"top":"AdminApplicantIdsInfo_top__ry53A","form":"AdminApplicantIdsInfo_form__6JEwQ","input":"AdminApplicantIdsInfo_input__gxFR0"};